/**
 * @desc 时效告警-分页查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.TimelinessDashboardWarnRecordResponseDto>
>;
export function request(
  params: API.basics.timelinessDashboardWarnRecord.pageList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/timelinessDashboardWarnRecord/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
